export const colors: Array<string> = [
  'rgba(255, 183, 98, 1)',
  'rgba(0, 97, 255, 1)',
  'rgba(35, 193, 243, 1)',
  'rgba(156, 98, 229, 1)',
  'rgba(0, 163, 137, 1)'
];
